import { z } from 'zod'
import messages from '../messages'

// E5 (WI 513) — the lean "register a customer under an existing Tenant" form. Per §6.2 it captures only
// the customer name, the Account Owner's details, and the required default currency; address / location
// are deliberately omitted (the backend stores a NULL location, set later via the edit flow). Currency is
// a required visible choice with no Tenant-inheritance fallback (Q-E5-4).
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const registerCustomerSchema = z.object({
  name: z
    .string()
    .min(1, messages.customerNameRequired.defaultMessage)
    .max(250, 'Customer Name must be maximum 250 characters'),
  accountOwnerFirstName: z
    .string()
    .min(1, messages.aoFirstNameRequired.defaultMessage)
    .max(150, 'First name must be maximum 150 characters'),
  accountOwnerLastName: z
    .string()
    .min(1, messages.aoLastNameRequired.defaultMessage)
    .max(150, 'Last name must be maximum 150 characters'),
  accountOwnerEmail: z
    .string()
    .min(1, messages.aoEmailRequired.defaultMessage)
    .max(250, 'Email must be maximum 250 characters')
    .refine((email) => emailRegex.test(email), messages.aoEmailInvalid.defaultMessage),
  accountOwnerPhone: z
    .string()
    .max(15, 'Phone must be maximum 15 characters')
    .optional(),
  defaultCurrencyId: z
    .union([z.number().min(1, messages.defaultCurrencyIsRequired.defaultMessage), z.undefined()])
    .refine((val) => val !== undefined && val > 0, {
      message: messages.defaultCurrencyIsRequired.defaultMessage,
    }),
})

export type RegisterCustomerFormData = z.infer<typeof registerCustomerSchema>
